
import iconCreateCategory from '../../../assets/images/InvestmentPortfolio/icon-create-category.svg'
import iconPlus from '../../../assets/images/InvestmentPortfolio/icon-plus.png'
import iconChart from '../../../assets/images/InvestmentPortfolio/icon-chart.png'
import iconUser from '../../../assets/images/InvestmentPortfolio/icon-user.svg'

import './PersonalDirectory.scss'
import TableList from './TableList'

export default function PersonalDirectory() {
  const data: any = [];

  return (
    <>
      <div className='Uinzy8koVI'>
        <div className='qttjiunuap'>
          <div className='ffonhjdcqt'><img className="AzmMuJODYQ" alt="" src={iconUser} /> Danh mục cá nhân</div>
          <div className='ckymjfzqrr'>
            <div className='nlitiunppf'>
              <div className='ubxhedikxo'><img src={iconCreateCategory} alt="" className='qakxctvonq' /></div>
              <div className='ouetszlkba'>Tư vấn danh mục</div>
            </div>
            <div className='nlitiunppf'>
              <div className='ubxhedikxo'><img src={iconPlus} alt="" className='qakxctvonq' /></div>
              <div className='ouetszlkba'>Thêm mã</div>
            </div>
          </div>
        </div>
        <div className='hsrojjntym'>
          <div className='rvtheozjaa'>
            <TableList data={data} showRemove={true} />
          </div>
        </div>
      </div>
    </>
  )
}